import React from "react";
import ClientService from "../services/clients";
import ClientList from "../components/clients/clientlist";
import ClientEdit from "../components/clients/clientedit";
import ActionButton from '../components/layout/actionButtons';

import Search from "../components/general/search";
class Clients extends React.Component {
  constructor(props) {
    super(props);
    this.state = { items: [],  filterItems: [], item: undefined };
  }

  componentDidMount() {
    if (!this.props.match.params.id) {

      this.getItems();

      this.props.handleMenu(
        {
          title: 'Klanten',
          handleActions: <ActionButton {...this.props} linkNewItem='/clients/0'></ActionButton>
        })

    } else {
      if (this.props.match.params.id === '0') {
        this.setState({ item: {} })
      } else {
        ClientService.get(this.props.match.params.id).then(
          (result) => {
            this.setState({ item: result })
          },
          (err) => {
            this.props.handleMessage({ title: "Kan de gegevens niet ophalen" });
            this.props.history.push('/clients')
          }
        )
      }

      this.props.handleMenu(
        {
          title: 'Klant',
          showBackButton:true,
          handleActions: <ActionButton {...this.props}  handleSave={this.handleSave}></ActionButton>
        })
    }
  }

  getItems() {
    ClientService.get().then(
      result => {
        this.setState({ items: result,filterItems:result });
      },
      error => {
        console.log("error", error);
      }
    );
  }

  handleUpdate = (item) => {
    this.setState({ item: item });
  }

  handleSave = () => {
    let item = this.state.item;
    if (item.name && item.clientnumber) {
      ClientService.save(item).then(
        result => {
          this.props.history.push('/clients')
        },
        error => {
          this.props.handleMessage({ title: "Het opslaan is mislukt" });
        }
      );
    } else {
      this.props.handleMessage({ title: "Gegevens zijn niet compleet" });
    }
  }

  handleDelete(item) {
    ClientService.delete(item._id).then(
      result => {
        this.props.history.push('/clients');
      },
      error => {
        this.props.handleMessage({ title: "Fout bij het verwijderen." });
      }
    );
  }

  handleEdit = (item) =>{
    this.props.history.push('/clients/'+item._id);
  }

  handleSearch = (search) => {
    let filterItems = this.state.items;
    filterItems = filterItems.filter((item) => { return (JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase()) >= 0) });
    this.setState({ filterItems });
    if(search==='import'){
      ClientService.import();
    }
  }
  compare(a,b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }
  render() {
    return (
      <div>
         {
          this.state.item
            ?
            <ClientEdit
              {...this.props}
              item={this.state.item}
              handleUpdate={this.handleUpdate}
            />
            :
            <React.Fragment>
               <Search handleSearch={this.handleSearch} />
              <ClientList items={this.state.filterItems.sort(this.compare)} handleEdit={this.handleEdit} />
            </React.Fragment>     
        }
      </div>
    );
  }
}
export default Clients;
